import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    dimensions: data?.dimensions?.toLowerCase() === "three" ? 2 : 1,
    category_ids:
      data?.categories?.map((c) => ({ label: c.name, value: c.id })) || [],
    for_whole_cart: data?.for_whole_cart || false,
  };
};
export const structure = (
  supportedLang,
  categories,
  t,
  fetchCategories,
  categoriesLoading,
  categoriesCount,
) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "image",
        label: `${t("wrappers_wraps.wrap_photo")}*`,
        placeholder: t("wrappers_wraps.upload_placeholder"),
        text: t("wrappers_wraps.file_size_limit"),
        width: "47%",
      },

      {
        width: "47%",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_wraps.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_wraps.write_name_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_wraps.name_ar"),
        width: "47%",
        placeholder: t("wrappers_wraps.write_name_ar"),
      },
      {
        name: `dimensions`,
        kind: "radioBox",
        label: t("wrappers_wraps.dimensions"),
        width: "47%",
        options: [
          { label: t("wrappers_wraps.two"), value: 1 },
          { label: t("wrappers_wraps.three"), value: 2 },
        ],
      },
      {
        name: `category_ids`,
        kind: "multiSelect",
        label: t("products.label_recommended_categories"),
        width: "47%",
        placeholder: t("products.placeholder_choose_categories"),
        options: categories,
        onOpen: categories?.length <= 1 && fetchCategories,
        isLoading: categoriesLoading,
        getList: fetchCategories,
        count: categoriesCount,
      },
      {
        name: `for_whole_cart`,
        kind: "checkbox",
        label: t("wrappers_wraps.for_whole_cart") || "For Whole Cart",
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    image: Yup.string().required("Required"),
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    ar: Yup.object().shape({
      name: Yup.string(),
    }),
    dimensions: Yup.number(),
    category_ids: Yup.array(),
    for_whole_cart: Yup.boolean(),
  });
